import * as React from "react";

import { IWorksheetState } from "./interfaces";
import { WS_SLUG } from "./wsDefs";
import { getWsById } from "./wsHelpers";

const humanize = require("underscore.string/humanize");
const styles = require("./styles.module.scss");

const wsIdToSlug = (worksheets, wsId) => {
  const ws = getWsById(worksheets, wsId);
  if (!ws) {
    throw new Error("not reached");
  }
  const slugFunc = WS_SLUG[ws.name];
  if (typeof slugFunc !== "function") {
    return humanize(ws.name);
  }
  return slugFunc(ws);
};

interface IProps {
  worksheets: IWorksheetState[];
  wsIdPath: string[];
  setCurrentWsId: Function;
}

const Breadcrumbs: React.SFC<any> = ({ worksheets, wsIdPath, setCurrentWsId }) => (
  <div className={styles.crumbs}>
    <span className={styles.crumbs__icon}>worksheets</span>
    <ol className={styles.crumbs__list}>
      {wsIdPath.map((wsId, idx) => (
        <li key={wsId} className={styles.crumbs__item} onClick={() => setCurrentWsId(wsId)}>
          {idx > 0 && (
            <span className={styles.crumbs__angle}>
              <i className="fa fa-fw fa-angle-right" />
            </span>
          )}
          {wsIdToSlug(worksheets, wsId)}
        </li>
      ))}
    </ol>
  </div>
);

export default Breadcrumbs;
